import NextBackgroundVideo from 'next-video/background-video';
import React from 'react';

export const BackgroundVideo = (
  props: React.ComponentProps<typeof NextBackgroundVideo>
) => <NextBackgroundVideo {...props} disableTracking />;
